module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web7.c18541fc.png";